import { Controller } from 'stimulus'
import './phone_field_controller.css'
import { attachInternationalPhone } from '~/site/behaviors/international_phone/main'

export default class extends Controller {
  static targets = ['numberField', 'countryCodeField']

  connect() {
    attachInternationalPhone(this.numberFieldTarget, {
      countryCodeField: this.hasCountryCodeFieldTarget
        ? this.countryCodeFieldTarget
        : null,
      autoPlaceholder: 'aggressive',
    })
  }
}
